module.exports = __webpack_public_path__ + "img/hotel5.dd8c7100.png";